import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { UpdateEmployeeForm } from '../../modules';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';
import { useUser } from '../../utils/hooks/auth';

const EmployeeUpdateView = () => {
    const { params: { id } } = useRouteMatch();
    const { isAdmin } = useUser();

    return (
        <EditScreenLayout isBackButtonShown={isAdmin} path={routePaths.employee}>
            <UpdateEmployeeForm employeeId={id} />
        </EditScreenLayout>
    );
};


export default EmployeeUpdateView;
